import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Skeleton for the results for the Policy Library Listing
 * Displays when the results are loading from the Confluence Search API
 */
export default function ResultsSkeleton() {

   return (
       <>
           {Array.from({ length: 5 }).map((_, letterIndex) => (
               <div key={`letter-${letterIndex}`} className="letter-group skeleton">
                   <div className="letter-title"><h2><Skeleton width={31} /></h2></div>
                   <div className="letter-results">
                       <ul>
                           {Array.from({ length: 3 }).map((_, policyIndex) => (
                               <li key={`policy-${letterIndex}-${policyIndex}`}>
                                   <h3>
                                      <Skeleton width={320} />
                                   </h3>
                               </li>
                           ))}
                       </ul>
                   </div>
               </div>
           ))}
       </>
   );


}